import { MQ_TABLET } from '../../../../constants';
import { MediaQueryStyleSheet } from 'react-native-responsive';

export default MediaQueryStyleSheet.create(
  {
    root: {
      flex: 1,
    },
    legendHeader: {
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      marginBottom: 10,
    },
    legendBarChart: {
      top: -20,
    },
    legendItem: {
      height: 30,
      marginBottom: 15,
      flexBasis: '50%',
    },
    legendItemBody: {
      marginLeft: 25,
      marginRight: 25,
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    legendBody: {
      flex: 1,
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexDirection: 'row',
      flexWrap: 'wrap',
    },
    legendText: {
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    legendBar: {
      flexGrow: 1, borderBottomWidth: 1, borderBottomColor: '#252F44'
    }
  },
  {
    [MQ_TABLET]: {
      root: {
        width: '100%',
      }
    }
  }
);
